<template>
  <unicom-layout-pagina>
    <unicom-layout-home
      titulo="RNP | Rede nacional de prestadores"
      :codigoUnimed="zeroEsquerda(codigoUnimedUsuarioMixin)"
      :nomeUnimed="letraMaiusculaCadaPalavra(unimedSelecionadaNomeMixin)"
      :listaCartoes="listaTelasFilter"
      @click-cartao="redirecionar"
    />
  </unicom-layout-pagina>
</template>

<script>
import HomeNavbarMixin from "@/shared/mixin/HomeNavbarMixin";

export default {
  name: "Home",
  mixins: [HomeNavbarMixin]
};
</script>
